import PropTypes from 'prop-types';
import { Content, ContentWrapper, Wrapper } from './styled';

function OnBoardingLayout({ children, className = '' }) {
  return (
    <Wrapper>
      <ContentWrapper className={className}>
        <Content>{children}</Content>
      </ContentWrapper>
    </Wrapper>
  );
}

OnBoardingLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OnBoardingLayout;
